import { render, staticRenderFns } from "./BankTransactionDetail.vue?vue&type=template&id=ef189608&scoped=true&"
import script from "./BankTransactionDetail.vue?vue&type=script&lang=js&"
export * from "./BankTransactionDetail.vue?vue&type=script&lang=js&"
import style0 from "./BankTransactionDetail.vue?vue&type=style&index=0&id=ef189608&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef189608",
  null
  
)

export default component.exports